/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackerrorheading3Inputs */

const en_authcallbackerrorheading3 = /** @type {(inputs: Authcallbackerrorheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't sign you in`)
};

const pt_authcallbackerrorheading3 = /** @type {(inputs: Authcallbackerrorheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível autenticar`)
};

/**
* | output |
* | --- |
* | "Couldn't sign you in" |
*
* @param {Authcallbackerrorheading3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackerrorheading3 = /** @type {((inputs?: Authcallbackerrorheading3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackerrorheading3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackerrorheading3(inputs)
	return pt_authcallbackerrorheading3(inputs)
});
export { authcallbackerrorheading3 as "authCallbackErrorHeading" }